import * as Validator from 'validatorjs';

const isValidUrl = value => {
  if (!value || value.trim() === '') return true;

  const url = value.trim();

  // Pattern to match various URL formats:
  // - google.com
  // - www.google.com
  // - https://google.com
  // - http://google.com
  // - ftp://example.com
  const urlPattern = /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(?:\/[^\s]*)?$/;

  return urlPattern.test(url);
};

Validator.register(
  'flexible_url',
  isValidUrl,
  'The :attribute format is invalid.',
);

export const validationMessages = {
  required: 'This value is required.',
  email: 'This format of the email is invalid',
  numeric: 'must be a number',
  flexible_url: 'This format of the URL is invalid',
  max: {
    string: 'This should be lower than or equal to :max.',
    numeric: 'Must be less than or equal to :max',
  },
  min: {
    string: 'This should be greater than or equal to :min characters.',
    numeric: 'Must be greater than or equal to :min',
  },
};

export const scrollToFirstError = () => {
  const firstErrorElement = document.querySelector('.inline-error');
  if (firstErrorElement) {
    const elementRect = firstErrorElement.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset;
    const offset = 100; // Adjust based on header height
    const scrollToPosition = absoluteElementTop - offset;

    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth',
    });

    setTimeout(() => {
      firstErrorElement.focus();
    }, 500);
  }
};

export const clearFieldError = (formRef, fieldName) => {
  if (!formRef.current) return;

  const domElement = formRef.current.querySelector(`[name="${fieldName}"]`);
  if (domElement) {
    domElement.classList.remove('inline-error');

    const errorMessage = formRef.current.querySelector(
      `[data-error-message="${fieldName}"]`,
    );
    if (errorMessage) {
      errorMessage.remove();
    }
  }
};

export const clearValidationErrors = formRef => {
  if (!formRef.current) return;

  formRef.current.querySelectorAll('.error-message').forEach(error => {
    error.remove();
  });

  formRef.current.querySelectorAll('.inline-error').forEach(error => {
    error.classList.remove('inline-error');
  });
};

export const addValidationErrors = (formRef, errors) => {
  if (!formRef.current) return;

  Object.keys(errors).forEach(key => {
    const domElement = formRef.current.querySelector(`[name="${key}"]`);
    if (domElement) {
      domElement.classList.add('inline-error');
      const markup = `
        <div class="error-message" data-error-message="${key}">
          <span class="filled">
            <label class="inline inline-error-message">
              ${errors[key][0]}
            </label>
          </span>
        </div>
      `;
      domElement.insertAdjacentHTML('afterend', markup);
    }
  });
};

export const validateForm = (formData, isEdit = false, workflowMode = 'standard') => {
  const rules = {
    exhibitor_type: 'required',
    company_name: 'required',
    website_url: 'required|flexible_url',
    work_description: 'required|max:600',
    years_experience: workflowMode === 'exhibitor_application' && !isEdit ? 'numeric|min:0' : 'required|numeric|min:0',
  };

  const data = {
    exhibitor_type: formData.exhibitor_type,
    company_name: formData.company_name,
    title: formData.title,
    website_url: formData.website_url,
    work_description: formData.work_description,
    years_experience: formData.years_experience,
  };

  const validation = new Validator(data, rules, validationMessages);

  if (validation.fails()) {
    return { isValid: false, errors: validation.errors.errors };
  }

  return { isValid: true, errors: {} };
};
